import React, {Component} from 'react';
import {Row, Col, Table, Spin, Button, Form,Radio, Input, Modal, Upload, Icon} from 'antd';
import {api, app} from "../../app";
import utils from "../../utils";
import config from "../../config";

const FormItem = Form.Item;
const RadioGroup = Radio.Group

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

class MMEditType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            c_loading: true,
            classList: [],
            sel_class1: 0,
            sel_class2: 0,
            update_info: null,
            parent_id: null,
            imageUrl: '',
        };
    }

    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.ClassList();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 分类集合
     * @returns {Promise<any>}
     * @constructor
     */
    ClassList = async () => {
        await this.setData({c_loading: true});
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type:1,
        };
        let {flag, data, msg} = await app.post(api.MallClassListing, params);
        let state = {c_loading: false};
        if (flag === 1) {
            state.classList = data;
        } else {
            app.alert(msg, 'warn');
        }
        await this.setData(state);
    }

    /**
     * 删除类型
     * @param id
     */
    handleDeleteType = (id) => {

    }

    /**
     * 添加类型
     * @param class_name
     * @param parent_id
     * @param url
     * @returns {Promise<boolean>}
     */
    handleAddType = async (class_name, parent_id, status, url) => {
        let params = {
            parent_id,
            class_name,
            status,
            url,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        let {flag, msg} = await app.post(api.MallClassAdd, params);
        if (flag === 1) {
            app.alert('添加成功', 'success');
            return true;
        } else {
            app.alert(msg, 'warn');
            return false;
        }
    }

    /**
     * 提交修改
     */
    handleEdit = async (parent_id, class_id, class_name, status, url) => {
        let params = {
            class_id,
            parent_id,
            class_name,
            status,
            url,
            indexno: app.getData('indexno'),
            account: app.getData('account')
        };
        let {flag, msg} = await app.post(api.MallClassEdit, params);
        if (flag === 1) {
            app.alert('修改成功', 'success');
            return true;
        } else {
            app.alert(msg, 'warn');
            return false;
        }
    }

    /**
     * 提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (err, {class_name, status, url}) => {
            if (!err) {
                if (this.state.submit_loading) return false;
                let {parent_id, update_info} = this.state;
                let path = '';
                url = url[url.length - 1];
                if (url && url.response && url.response.data && url.response.data.url) {
                    path = url.response.data.url;
                }
                if (!path) {
                    app.alert('图片未上传成功', 'warn');
                    return;
                }
                await this.setData({submit_loading: true});
                let flag = false;
                if (update_info) {
                    flag = await this.handleEdit(parent_id, update_info.id, class_name, status, path);
                } else {
                    flag = await this.handleAddType(class_name, parent_id, status, path);
                }
                await this.setData({submit_loading: false});
                if (flag) {
                    await this.handleCloseModal();
                    await this.ClassList();
                }
            }
        });
    }

    /**
     * 打开编辑框
     * @param update_info
     * @param parent_id
     * @returns {Promise<void>}
     */
    handleOpenModal = async (parent_id, update_info = null) => {
        console.log(update_info);
        let state = {modal_visible: true, parent_id, update_info};
        if (update_info) {
            this.props.form.setFieldsValue({
                class_name: update_info.class_name,
                status: update_info.status,
                url: [{
                    response: {
                        data: {
                            url: update_info.thumb_images
                        }
                    }
                }],
            });
            state.imageUrl = config.imgUrl + update_info.thumb_images;
        }
        await this.setData(state);
    }

    /**
     * 关闭编辑框
     * @param id
     * @returns {Promise<void>}
     */
    handleCloseModal = async () => {
        await this.setData({modal_visible: false, parent_id: null, update_info: null});
        this.props.form.resetFields();
    }

    normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    }

    /**
     * 上传之前
     * @param file
     * @returns {*}
     */
    beforeUpload = (file) => {
        console.log(file);
        const isLt2M = file.size / 1024 < 200;
        if (!isLt2M) {
            app.alert('图片最大200KB!', 'error');
            return Promise.reject(false);
        }
        return Promise.resolve(true);
    }

    handleChange = (info) => {
        if (info.file.status === 'uploading') {
            this.setState({up_loading: true});
            return;
        }
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, imageUrl => this.setState({
                imageUrl,
                up_loading: false,
            }));
        }
    }

    render() {
        let {classList, sel_class1, sel_class2, c_loading, c_loading2, c_loading3, submit_loading, modal_visible, update_info, up_loading, imageUrl} = this.state,
            classList2 = classList[sel_class1] || {},
            classList3 = classList2.subclass ? classList2.subclass[sel_class2] : {},
            {getFieldDecorator, getFieldValue} = this.props.form,
            fileList = getFieldValue('url'),
            formItemLayout = {
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 6},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 16},
                }
            },
            columns = [
                {
                    title: '分类图片',
                    dataIndex: 'thumb_images',
                    key: 'thumb_images',
                    width: '30%',
                    render(src) {
                        return (<span className="c2-img"><img src={config.imgUrl + src} alt="无"/></span>);
                    }
                },
                {
                    title: '分类名称',
                    dataIndex: 'class_name',
                    key: 'class_name',
                    width: '40%',
                },
                {
                    title: '操作',
                    dataIndex: 'parentid',
                    key: 'parentid',
                    width: '30%',
                    render: (parentid, record) => {
                        return (<span className="c2-link" onClick={() => this.handleOpenModal(parentid, record)}>修改</span>);
                    }
                },
            ];
        return (
            <div className="mall-manage-edit-type">
                <div className="page-title">编辑分类</div>
                <div className="page-content">
                    <div className="card1">
                        <div className="c-title">一级分类</div>
                        <Button className="add-btn" onClick={() => this.handleOpenModal(0)}>添加分类</Button>
                        <div className="c-content">
                            {
                                c_loading ?
                                    (<div style={{textAlign: 'center', height: 100, lineHeight: '100px'}}><Spin/>
                                    </div>) :
                                    classList.map((cla, i) => {
                                        return (
                                            <div className="cc-item" style={sel_class1 === i ? {borderColor: "#39c"} : {}}
                                                key={i} onClick={async () => {
                                                if (this.state.sel_class1 === i) return;
                                                await this.setData({c_loading2: true, c_loading3: true});
                                                await app.sleep(200);
                                                await this.setData({
                                                    c_loading2: false,
                                                    c_loading3: false,
                                                    sel_class1: i,
                                                    sel_class2: 0
                                                })
                                            }}>
                                            <span className="i-img">
                                                <img src={config.imgUrl + cla.thumb_images} alt="无图"/>
                                            </span>
                                                <span className="i-name">{cla.class_name}</span>
                                                <span className="i-link"
                                                      onClick={() => this.handleOpenModal(0, cla)}>修改</span>
                                            </div>
                                        );
                                    })
                            }
                        </div>
                    </div>
                    {/* 二级分类暂时隐藏 cwj 2022-06-09 */}
                    {/* {
                        classList && classList.length > 0 ?
                            (
                                <Row className="child-class">
                                    <Col span={11} className="card2">
                                        <div className="c-title">{classList2.class_name}</div>
                                        <Button className="add-btn" onClick={() => this.handleOpenModal(classList2.id)}>添加分类</Button>
                                        <div className="c-content">
                                            <Table columns={columns}
                                                locale={app.tbLocale(c_loading2)}
                                                dataSource={utils.addArrayKey(classList2.subclass || [])}
                                                size="small"
                                                scroll={{y: 600}}
                                                pagination={false}
                                                loading={c_loading2}
                                                onRow={(record, index) => {
                                                    return {
                                                        onClick: async () => {
                                                            if (this.state.sel_class2 === index) return;
                                                            await this.setData({c_loading3: true});
                                                            await app.sleep(200);
                                                            await this.setData({
                                                                c_loading3: false,
                                                                sel_class2: index
                                                            })
                                                        }
                                                    };
                                                }}
                                            />
                                        </div>
                                    </Col>
                                    {
                                        classList3.id ? (
                                            <Col span={11} offset={2} className="card2">
                                                <div className="c-title">{classList3.class_name}</div>
                                                <Button className="add-btn" onClick={() => this.handleOpenModal(classList3.id)}>添加分类</Button>
                                                <div className="c-content">
                                                    <Table columns={columns}
                                                        locale={app.tbLocale(c_loading3)}
                                                        dataSource={utils.addArrayKey(classList3.subclass || [])}
                                                        size="small"
                                                        scroll={{y: 600}}
                                                        pagination={false}
                                                        loading={c_loading3}
                                                    />
                                                </div>
                                            </Col>
                                        ) : null
                                    }
                                </Row>
                            ) : null
                    } */}
                    <Modal
                        title={update_info ? '修改分类' : '添加分类'}
                        visible={modal_visible}
                        okText="确定"
                        cancelText="取消"
                        maskClosable={false}
                        onOk={this.handleSubmit}
                        onCancel={this.handleCloseModal}
                        confirmLoading={submit_loading}
                    >
                        <Form>
                            <FormItem
                                {...formItemLayout}
                                label="分类图片"
                            >
                                {getFieldDecorator('url', {
                                    rules: [{required: true, message: "请上传分类图片。"}],
                                    valuePropName: 'fileList',
                                    getValueFromEvent: this.normFile,
                                })(
                                    <Upload
                                        accept='image/jpeg, image/jpg, image/png'
                                        action={config.serverUrl + api.ImageUpload}
                                        listType="picture-card"
                                        showUploadList={false}
                                        beforeUpload={this.beforeUpload}
                                        data={{
                                            token: app.getData('token'),
                                            indexno: app.getData('indexno'),
                                            account: app.getData('account'),
                                            upload_type: 'mall_class'
                                        }}
                                        name="image"
                                        onChange={this.handleChange}
                                    >
                                        {
                                            fileList && fileList.length > 0 ?
                                                (<img src={imageUrl} alt="" className="avatar"
                                                      style={{width: 81, height: 81}}/>) :
                                                (
                                                    <div>
                                                        <Icon type={up_loading ? 'loading' : 'plus'}/>
                                                        <div className="ant-upload-text">上传图片</div>
                                                    </div>
                                                )
                                        }
                                    </Upload>
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="分类名称"
                            >
                                {getFieldDecorator('class_name', {
                                    rules: [
                                        {required: true, message: "请填写分类图片。"}
                                    ]
                                })(
                                    <Input placeholder="请填写分类名称" maxLength={10}/>
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="状态"
                            >
                                {getFieldDecorator('status', {
                                    rules: [
                                        {required: true, message: "请选择状态。"}
                                    ]
                                })(
                                    <RadioGroup placeholder="请选择是否审核">
                                        <Radio value="0">禁用</Radio>
                                        <Radio value="1">启用</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Form>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default Form.create()(MMEditType);



// WEBPACK FOOTER //
// ./src/routes/mall_manage/MMEditType.jsx